export const checkIsDefined = (data: unknown) => typeof data !== "undefined";
